import { render, staticRenderFns } from "./member-order-redate.component.vue?vue&type=template&id=48123b48"
import script from "./member-order-redate.component.vue?vue&type=script&lang=js"
export * from "./member-order-redate.component.vue?vue&type=script&lang=js"
import style0 from "./member-order-redate.component.vue?vue&type=style&index=0&id=48123b48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports